import React, { Component } from 'react';

export const cloneItemElement = (elem, extraProps) => {
  return React.cloneElement(elem, {
      ...elem.props,
      ...extraProps,
    });
};
export const renderChildren = (children, extraProps) => {
  return React.Children.map(children, (child) => {
    return cloneItemElement(child, extraProps);
  });
};



// WEBPACK FOOTER //
// ./src/components/Menu/MenuUtil.js